/* eslint-disable import/prefer-default-export */

// Get window location
const getUrl = window.location;
// Compile base url
const baseUrl = `${getUrl.protocol}//${getUrl.host}`;
// Get template directory
const templateDir = `${baseUrl}/wp-content/themes/samenklimaatactief`;

// Javascript media query's
const mediaQuery = {
  mobileLarge: window.matchMedia('(max-width: 640px)'),
};

export { baseUrl, templateDir, mediaQuery };
